(function () {
  'use strict';
  // Signup is a native Shopify customer form since 2026-10-31 (snippets/solis-newsletter-form.liquid). After the
  // redirect, reopen the PDP welcome line so the shopper sees the success message they were looking at.
  if (/[?&]customer_posted=true/.test(window.location.search) || window.location.hash === '#SolisWelcomeOffer') {
    var line = document.getElementById('SolisWelcomeLine');
    if (line && line.querySelector('.sr-newsletter-form__status')) line.open = true;
  }
  document.addEventListener('variant:update', function (event) {
    if (event.target.closest?.('quick-add-component, swatches-variant-picker-component, dialog')) return;
    var variant = event.detail?.resource;
    var productId = event.detail?.data?.productId;
    if (!variant || typeof variant.price !== 'number' || !productId) return;
    document.querySelectorAll('solis-welcome-offer').forEach(function (offer) {
      if (String(productId) !== offer.dataset.productId) return;
      var savings = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
      }).format(Math.round(variant.price * 0.05) / 100);
      offer.dataset.price = variant.price;
      offer.querySelector('[data-sr-welcome-label]').textContent = offer.dataset.label.replace('__SAVINGS__', savings);
    });
  });
})();
